import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 8a3 3 0 1 1 -3 3l.005 -.176a3 3 0 0 1 2.995 -2.824","key":"svg-0"}],["path",{"d":"M18 7a4 4 0 0 1 4 4v2a1 1 0 0 1 -1 1h-11a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1z","key":"svg-1"}],["path",{"d":"M21 15a1 1 0 0 1 0 2h-18a1 1 0 0 1 0 -2z","key":"svg-2"}]]

const IconBedFlatFilled = createReactComponent('filled', 'bed-flat-filled', 'BedFlatFilled', __iconNode);

export default IconBedFlatFilled;